<template>
    <b-form-radio :value="value">
        <span>
            en tant que <strong>salarié</strong>,
            <strong>agent</strong>,
            <strong>élu</strong> ou
            <strong>bénévole</strong>
        </span>

        <span class="cursus-radios__help">
            d’une structure (équipe artistique, lieu de diffusion, festival, ...) / d’une collectivité / d’un établissement public
        </span>
    </b-form-radio>
</template>

<script>
    /**
     * used in AccountForm too
     */
    export default {
        props: {
            value: null,
        }
    }
</script>
